export const SETSHOWLOCKOUTCONTROLS = 'SETSHOWLOCKOUTCONTROLS';
export const SETPRINTFRIENDLY = 'SETPRINTFRIENDLY';
export const SETSMALLTOOLBAR = 'SETSMALLTOOLBAR';
export const SETICONSETTINGSVISIBLE = 'SETICONSETTINGSVISIBLE';
export const TOGGLEPROPERTYHIDDENONRAIDSPOT = 'TOGGLEPROPERTYHIDDENONRAIDSPOT';
export const TOGGLETEAMBADGES = 'TOGGLETEAMBADGES';
export const TOGGLEPROPERTIES = 'TOGGLEPROPERTIES';
export const TOGGLESATISFIEDCHECKS = 'TOGGLESATISFIEDCHECKS';
export const TOGGLEFORCEMAINNAMES = 'TOGGLEFORCEMAINNAMES';
export const EVENTTABLEZOOMIN = 'EVENTTABLEZOOMIN';
export const EVENTTABLEZOOMOUT = 'EVENTTABLEZOOMOUT';
export const EVENTTABLEZOOMRESET = 'EVENTTABLEZOOMRESET';
export const ATTENDANCEOVERVIEWWIDTHINC = 'ATTENDANCEOVERVIEWWIDTHINC';
export const ATTENDANCEOVERVIEWWIDTHDEC = 'ATTENDANCEOVERVIEWWIDTHDEC';
export const TOGGLEATTENDANCEOVERVIEWREVERSELOCKOUTS = 'TOGGLEATTENDANCEOVERVIEWREVERSELOCKOUTS';
export const TOGGLESHOWGROUPSTOROSTER = 'TOGGLESHOWGROUPSTOROSTER';
export const SETEVENTTABLEALIGNMENT = 'SETEVENTTABLEALIGNMENT';

export default {
  state: () => ({
    showlockoutcontrols: localStorage.getItem( 'showLockoutControls' ) == 'true',
    printfriendly: localStorage.getItem( 'printFriendly' ) == 'true',
    smalltoolbar: localStorage.getItem( 'smallToolbar' ) == 'true',
    iconsettingsvisible: localStorage.getItem( 'iconsettingsVisible' ) == 'true',
    hiddenPropertiesOnRaidSpot: JSON.parse( localStorage.getItem( 'hiddenPropertiesOnRaidSpot') ),
    showTeamBadges: localStorage.getItem( 'hideTeamBadges' ) != 'true',
    showProperties: localStorage.getItem( 'hideProperties' ) != 'true',
    showSatisfiedChecks: localStorage.getItem( 'hideSatisfiedChecks' ) != 'true',
    forceMainNames: localStorage.getItem( 'forceMainNames' ) == 'true',
    eventtablefontsize: parseInt( localStorage.getItem( 'eventTableFontSize' ) || '12' ),
    attendanceoverviewwidth: parseInt( localStorage.getItem( 'attendanceOverviewWidth' ) || '455' ),
    attendanceoverviewreverselockouts: localStorage.getItem( 'attendanceOverviewReverseLockouts' ) == 'true',
    showgroupstoroster: localStorage.getItem( 'showGroupsToRoster' ) == 'true',
    eventtablealignment: localStorage.getItem( 'eventTableAlignment' ) || 'center',
  }),

  getters: {
    isPropertyVisibleOnRaidSpot: ( state ) => ( property ) => {
      if( !property ) return false
      if( !state.hiddenPropertiesOnRaidSpot ) return true
      if( state.hiddenPropertiesOnRaidSpot[ property['.key'] ] ) return false
      return true
    },
  },

  mutations: {
    [SETSHOWLOCKOUTCONTROLS] ( state, value ) {
      state.showlockoutcontrols = value
      localStorage.setItem( 'showLockoutControls', value )
    },
    [SETPRINTFRIENDLY] ( state, value ) {
      state.printfriendly = value
      localStorage.setItem( 'printFriendly', value )
    },
    [SETSMALLTOOLBAR] ( state, value ) {
      state.smalltoolbar = value
      localStorage.setItem( 'smallToolbar', value )
    },
    [SETICONSETTINGSVISIBLE] ( state, value ) {
      state.iconsettingsvisible = value
      localStorage.setItem( 'iconsettingsVisible', value )
    },
    [TOGGLEPROPERTYHIDDENONRAIDSPOT] ( state, property ) {
      if( !state.hiddenPropertiesOnRaidSpot ) state.hiddenPropertiesOnRaidSpot = {}
      state.hiddenPropertiesOnRaidSpot[ property['.key'] ] = !state.hiddenPropertiesOnRaidSpot[ property['.key' ]]
      localStorage.setItem( 'hiddenPropertiesOnRaidSpot', JSON.stringify( state.hiddenPropertiesOnRaidSpot) )
    },
    [TOGGLETEAMBADGES] ( state ) {
      state.showTeamBadges = !state.showTeamBadges
      localStorage.setItem( 'hideTeamBadges', !state.showTeamBadges )
    },
    [TOGGLEPROPERTIES] ( state ) {
      state.showProperties = !state.showProperties
      localStorage.setItem( 'hideProperties', !state.showProperties )
    },
    [TOGGLESATISFIEDCHECKS] ( state ) {
      state.showSatisfiedChecks = !state.showSatisfiedChecks
      localStorage.setItem( 'hideSatisfiedChecks', !state.showSatisfiedChecks )
    },
    [TOGGLEFORCEMAINNAMES] ( state ) {
      state.forceMainNames = !state.forceMainNames
      localStorage.setItem( 'forceMainNames', state.forceMainNames )
    },
    [EVENTTABLEZOOMRESET] ( state ) {
      state.eventtablefontsize = 12
      localStorage.removeItem( 'eventTableFontSize' )
    },
    [EVENTTABLEZOOMIN] ( state ) {
      let oldsize = state.eventtablefontsize || 12
      let newsize = Math.min( oldsize + 2, 64 )
      state.eventtablefontsize = newsize
      localStorage.setItem( 'eventTableFontSize', newsize )
    },
    [EVENTTABLEZOOMOUT] ( state ) {
      let oldsize = state.eventtablefontsize || 12
      let newsize = Math.max( oldsize - 2, 2 )
      state.eventtablefontsize = newsize
      localStorage.setItem( 'eventTableFontSize', newsize )
    },
    [ATTENDANCEOVERVIEWWIDTHINC] ( state ) {
      let oldwidth = state.attendanceoverviewwidth || 455
      let newwidth = Math.min( oldwidth + 50, 855 )
      state.attendanceoverviewwidth = newwidth
      localStorage.setItem( 'attendanceOverviewWidth', newwidth )
    },
    [ATTENDANCEOVERVIEWWIDTHDEC] ( state ) {
      let oldwidth = state.attendanceoverviewwidth || 455
      let newwidth = Math.max( oldwidth - 50, 255 )
      state.attendanceoverviewwidth = newwidth
      localStorage.setItem( 'attendanceOverviewWidth', newwidth )
    },
    [TOGGLEATTENDANCEOVERVIEWREVERSELOCKOUTS] ( state ) {
      state.attendanceoverviewreverselockouts = !state.attendanceoverviewreverselockouts
      localStorage.setItem( 'attendanceOverviewReverseLockouts', state.attendanceoverviewreverselockouts )
    },
    [TOGGLESHOWGROUPSTOROSTER] ( state ) {
      state.showgroupstoroster = !state.showgroupstoroster
      localStorage.setItem( 'showGroupsToRoster', state.showgroupstoroster )
    },
    [SETEVENTTABLEALIGNMENT] ( state, value ) {
      if( value != 'left' && value != 'center' && value != 'right' ) return
      state.eventtablealignment = value
      localStorage.setItem( 'eventTableAlignment', value )
    }
  },

  actions: {
  },
}